export default [{
  nome: 'Acre',
  codigo: 'AC'
},
{
  nome: 'Alagoas',
  codigo: 'AL'
},
{
  nome: 'Amazonas',
  codigo: 'AM'
},
{
  nome: 'Amapá',
  codigo: 'AP'
},
{
  nome: 'Bahia',
  codigo: 'BA'
},
{
  nome: 'Ceará',
  codigo: 'CE'
},
{
  nome: 'Distrito Federal',
  codigo: 'DF'
},
{
  nome: 'Espirito Santo',
  codigo: 'ES'
},
{
  nome: 'Goiás',
  codigo: 'GO'
},
{
  nome: 'Maranhão',
  codigo: 'MA'
},
{
  nome: 'Mato Grosso',
  codigo: 'MT'
},
{
  nome: 'Mato Grosso do Sul',
  codigo: 'MS'
},
{
  nome: 'Minas Gerais',
  codigo: 'MG'
},
{
  nome: 'Pará',
  codigo: 'PA'
},
{
  nome: 'Paraíba',
  codigo: 'PB'
},
{
  nome: 'Paraná',
  codigo: 'PR'
},
{
  nome: 'Pernambuco',
  codigo: 'PE'
},
{
  nome: 'Piauí',
  codigo: 'PI'
},
{
  nome: 'Rio de Janeiro',
  codigo: 'RJ'
},
{
  nome: 'Rio Grande do Norte',
  codigo: 'RN'
},
{
  nome: 'Rio Grande do Sul',
  codigo: 'RS'
},
{
  nome: 'Santa Catarina',
  codigo: 'SC'
},
{
  nome: 'São Paulo',
  codigo: 'SP'
},
{
  nome: 'Sergipe',
  codigo: 'SE'
},
{
  nome: 'Rondônia',
  codigo: 'RO'
},
{
  nome: 'Roraima',
  codigo: 'RR'
},
{
  nome: 'Tocantins',
  codigo: 'TO'
}
]



// WEBPACK FOOTER //
// ./src/constants/estados.js